"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const clsx_1 = __importDefault(require("clsx"));
const pluralize_1 = __importDefault(require("pluralize"));
const MemberSongwriterHandler = ({ type, count, firstNavLink, onClick }) => {
    const { popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const isOpen = popupStore.rightsholderTrayState;
    const isMemberHub = type === 'member';
    if (count === 0) {
        return null;
    }
    const label = isMemberHub ? (0, pluralize_1.default)('Member', count) : 'Songwriter Hub';
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('rightsholder-handler-component', isOpen && 'open'), "data-testid": 'rightsholder-handler' }, count === 1 && firstNavLink ? (react_1.default.createElement(react_router_dom_1.NavLink, { to: firstNavLink, className: "rightsholder-handler" },
        react_1.default.createElement("img", { src: common_1.ICONS.account, alt: "Top Rightsholder" }),
        react_1.default.createElement("span", { className: "bold" }, label))) : (react_1.default.createElement("div", { className: "rightsholder-handler", onClick: onClick },
        isOpen ? (react_1.default.createElement("img", { src: common_1.ICONS.chevron_drop_up, alt: "Close" })) : (react_1.default.createElement("img", { src: common_1.ICONS.account_multi, alt: "Top Rightsholders" })),
        react_1.default.createElement("span", { className: "bold" },
            label,
            " \u00A0",
            count > 1 && isMemberHub && react_1.default.createElement("span", { className: "count" }, count))))));
};
exports.default = (0, mobx_react_1.observer)(MemberSongwriterHandler);
